import { EasyField } from 'react-bootstrap-formutil';
import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import AssetsInfo from 'components/forms/AssetsInfo';
import InvestInfo from 'components/forms/InvestInfo';
import InvestTarget from 'components/forms/InvestTarget';
import values from 'stores/values';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import styles from './style.scss';

const Invest: React.FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const navigate = useNavigate();
    const { opt_perm: tradeType } = $formutil.$params;
    // tradeType === '1'表示用户选择了期权交易项
    const isOption = tradeType === '1'; // 是否有其他配置项
    const age = values.getAge();

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();

        onSubmit(() => {
            reportEventList('account');

            navigate('../contact');
        }, ev);
    };

    return (
        <form className={styles.root} noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('INVEST INFORMATION')}</h3>
            <AssetsInfo />
            <InvestTarget />
            {isOption && (
                <>
                    <h4 className="my-2">{__('Option Investment Experience')}</h4>
                    <InvestInfo name="opt" age={age} isOption minTradeYears={2} isMarsco />
                    <p className={styles.tips}>
                        * {__('I have read the ')}
                        <a href="https://www.tradeup.com/agreement/173" target="_blank" className="agreement">
                            {__('Characteristics and Risks of Standardized Options ')}
                        </a>
                        {__('and understand the risks')}
                    </p>
                </>
            )}
            <BackNextButtons />
            <EasyField name="account_capabilities" $defaultValue="CASH">
                <input type="hidden" />
            </EasyField>
        </form>
    );
};

export default withProgressForm({
    step: 3,
    id: 'invest',
    ensure: ['baseinfo', 'job'],
    basePath: 'esop'
})(Invest);
